import { useState } from 'react';

import useTranslations from '@/i18n/useTranslations';
import GoBackButton from '@/shared-components/buttons/components/GoBackButton';

import '../../artist-help/profile/styles.css';

export default function ProfileCollectorHelpSupportSubscriptionsPage() {
  const t = useTranslations('collectors_help.support_subscriptions');
  const [openSections, setOpenSections] = useState({
    whatAreSupportAndSubscriptions: false,
    support: false,
    subscriptions: false,
    difference: false,
    managingPayments: false,
    giftingSubscriptions: false,
  });

  function toggleSection(sectionKey) {
    setOpenSections((previous) => ({
      ...previous,
      [sectionKey]: !previous[sectionKey],
    }));
  }

  return (
    <section className="artist-help-category">
      <header className="artist-help-category__header">
        <GoBackButton alternativeRoute="/profile/collector-help" />
        <h1>{t('title')}</h1>
      </header>

      <div className="artist-help-category__body">
        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('whatAreSupportAndSubscriptions')}
            aria-expanded={openSections.whatAreSupportAndSubscriptions}
          >
            <h2>{t('sections.what_are_support_and_subscriptions.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.whatAreSupportAndSubscriptions ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.whatAreSupportAndSubscriptions && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.what_are_support_and_subscriptions.p1')}</p>
              <p>{t('sections.what_are_support_and_subscriptions.p2')}</p>
              <p>{t('sections.what_are_support_and_subscriptions.p3')}</p>
              <p>{t('sections.what_are_support_and_subscriptions.p4')}</p>
              <p>{t('sections.what_are_support_and_subscriptions.p5')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('support')}
            aria-expanded={openSections.support}
          >
            <h2>{t('sections.support.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.support ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.support && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.support.p1')}</p>
              <p>{t('sections.support.p2')}</p>

              <div className="artist-help-category__stack">
                <h3>{t('sections.support.how_it_works_title')}</h3>
                <ul>
                  <li>{t('sections.support.how_it_works_list_1')}</li>
                  <li>{t('sections.support.how_it_works_list_2')}</li>
                  <li>{t('sections.support.how_it_works_list_3')}</li>
                </ul>
              </div>

              <div className="artist-help-category__stack">
                <h3>{t('sections.support.what_it_means_title')}</h3>
                <p>{t('sections.support.p3')}</p>
                <p>{t('sections.support.p4')}</p>
              </div>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('subscriptions')}
            aria-expanded={openSections.subscriptions}
          >
            <h2>{t('sections.subscriptions.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.subscriptions ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.subscriptions && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.subscriptions.p1')}</p>
              <ul>
                <li>{t('sections.subscriptions.list_1')}</li>
                <li>{t('sections.subscriptions.list_2')}</li>
              </ul>
              <p>{t('sections.subscriptions.p2')}</p>

              <div className="artist-help-category__stack">
                <h3>{t('sections.subscriptions.what_you_receive_title')}</h3>
                <ul>
                  <li>{t('sections.subscriptions.what_you_receive_list_1')}</li>
                  <li>{t('sections.subscriptions.what_you_receive_list_2')}</li>
                  <li>{t('sections.subscriptions.what_you_receive_list_3')}</li>
                </ul>
                <p>{t('sections.subscriptions.p3')}</p>
              </div>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('difference')}
            aria-expanded={openSections.difference}
          >
            <h2>{t('sections.difference.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.difference ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.difference && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.difference.p1')}</p>
              <ul>
                <li>{t('sections.difference.list_1')}</li>
                <li>{t('sections.difference.list_2')}</li>
              </ul>
              <p>{t('sections.difference.p2')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('managingPayments')}
            aria-expanded={openSections.managingPayments}
          >
            <h2>{t('sections.managing_payments.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.managingPayments ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.managingPayments && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.managing_payments.p1')}</p>
              <p>{t('sections.managing_payments.p2')}</p>
              <ul>
                <li>{t('sections.managing_payments.list_1')}</li>
                <li>{t('sections.managing_payments.list_2')}</li>
                <li>{t('sections.managing_payments.list_3')}</li>
              </ul>
              <p>{t('sections.managing_payments.p3')}</p>
              <p>{t('sections.managing_payments.p4')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('giftingSubscriptions')}
            aria-expanded={openSections.giftingSubscriptions}
          >
            <h2>{t('sections.gifting_subscriptions.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.giftingSubscriptions ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.giftingSubscriptions && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.gifting_subscriptions.p1')}</p>
              <p>{t('sections.gifting_subscriptions.p2')}</p>
            </div>
          )}
        </section>
      </div>
    </section>
  );
}
